import { useFlags } from "launchdarkly-react-client-sdk";

/** Whether this user can launch to external systems, such as ads to Meta, through the agent. */
export function useExternalResourceLaunchEnabled(): boolean {
  const { externalResourceLaunch } = useFlags();
  return externalResourceLaunch === true;
}
